module.exports = __webpack_public_path__ + "img/nb_learner.cd0f848d.png";